// extracted by mini-css-extract-plugin
export default {"th":"UserRoleStep_th__z7PY2","control":"UserRoleStep_control__Vf5GW","icon":"UserRoleStep_icon__VE-Vj"};